import { render, staticRenderFns } from "./sorteos.vue?vue&type=template&id=3751491a&scoped=true&"
import script from "./sorteos.vue?vue&type=script&lang=js&"
export * from "./sorteos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3751491a",
  null
  
)

export default component.exports